import { render } from "./404View.vue?vue&type=template&id=18c8fdb7"
const script = {}

import exportComponent from "C:\\source\\kp1\\PartnerMypage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__